import React, { useEffect } from 'react';
import { useMatomo } from '@jonkoops/matomo-tracker-react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import Selectors from '../hooks/selectors';

const PageTracker = ({ children }) => {
  const { title } = Selectors.usePageTracker();
  const { trackPageView } = useMatomo();

  useEffect(() => {
    if (document.title !== title && hasMinimumLength(title)) {
      document.title = title;
      trackPageView({ documentTitle: title, href: document.URL });
    }
  }, [children, title]);

  return <>{children}</>;
};

export default PageTracker;
